/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_ToggleInputs */

const en_us2_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why we ask`)
};

const pt_br2_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que perguntamos`)
};

const es_419_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué preguntamos`)
};

const pt_pt2_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque perguntamos`)
};

const fr_fr2_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi on demande`)
};

const de_de2_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wir fragen`)
};

const it_it2_intake_why_toggle = /** @type {(inputs: Intake_Why_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché lo chiediamo`)
};

/**
* | output |
* | --- |
* | "Why we ask" |
*
* @param {Intake_Why_ToggleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_toggle = /** @type {((inputs?: Intake_Why_ToggleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_ToggleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_toggle(inputs)
	if (locale === "es-419") return es_419_intake_why_toggle(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_toggle(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_toggle(inputs)
	if (locale === "de-DE") return de_de2_intake_why_toggle(inputs)
	if (locale === "it-IT") return it_it2_intake_why_toggle(inputs)
	return en_us2_intake_why_toggle(inputs)
});
export { intake_why_toggle as "intake.why.toggle" }